import React, {useEffect, useRef, useState} from "react";
import * as Dialog from '@radix-ui/react-dialog';
import {useForm} from "react-hook-form";
import {AxiosError} from 'axios';
import axios from '../Utilities/axios.ts'
import {
    ProposalApprovalRequirement,
    ProposalPermissions,
    Staff
} from "./types.ts";
import {ProposalReopen} from "./ProposalReopen.tsx";
import {ClientEmailInput, FileInput, Subject} from "../Components/EmailComponents.tsx";
import {EmailContact, SubjectFields} from "../Components/EmailComponents.ts";
import {Contact} from "../Components/BaseTypes.ts";

export function SendEmail({
                              permissions,
                              signatureHtml,
                              dateApproved,
                              dateEmailed,
                              rootUrl,
                              loading,
                              errHandler,
                              resHandler,
                              issuesNotRequiringExtraApproval,
                              defaultRecipient,
                              clientContactList,
                              staffList,
                              subjectFields,
                              approvalRequirementList,
                              proposalId,
                              fromEmail
                          }: {
    permissions: ProposalPermissions,
    fromEmail: string,
    signatureHtml: string
    dateEmailed: string,
    dateApproved: string,
    rootUrl: string,
    loading: boolean,
    issuesNotRequiringExtraApproval: string[],
    errHandler: (e) => void,
    resHandler: (e) => void,
    defaultRecipient?: string,
    clientContactList: Contact[],
    staffList: Staff[],
    proposalId: number,
    approvalRequirementList: ProposalApprovalRequirement[],
    subjectFields: SubjectFields
}) {
    // props.permissions[""]
    console.log('axios defaults', axios.defaults);
    console.log('axios interceptors', axios.interceptors);

    const formRef = useRef();
    const [fileList, setFileList] = useState<File[]>([]);
    const [open, setOpen] = useState(false);

    const {handleSubmit, register, getValues, setValue, formState: {isDirty}} = useForm({
        defaultValues: {
            'recipients': defaultRecipient,
            'emailCCRecipients': '',
            'emailSubject': subjectFields.body,
            'body': '',
            'attachProposal': true,
            'attachments': null
        },
        mode: 'onChange',
    });

    useEffect(() => {
        if (isDirty) { // @ts-expect-error This function is defined as a browser include...
            handleChangeEvent();
        }
    }, [isDirty])

    const emailContactList: EmailContact[] = [
        ...clientContactList.map(c => ({
            'name': c.conFirstname + ' ' + c.conLastname,
            'email': c.conEmail
        })),
        ...staffList.map(s => ({
            'name': s.stfFirstname + ' ' + s.stfLastname,
            'email': s.stfBusEmail
        })),
    ];


    const onSubmit = () => {
        console.log(formRef.current);
        console.log(new FormData(formRef.current));
        axios.post(`${rootUrl}/send`, new FormData(formRef.current), {loadingMessage: 'disable'}).then((v) => {
            setOpen(false);
            resHandler(v);

        }).catch((err: AxiosError) => {
            setOpen(false);
            errHandler(err);
        });
    }

    return (
        <>
            <h3>Proposal Submission</h3>
            {!!dateEmailed && <p>Proposal has already been emailed</p>}

            <Dialog.Root open={open} onOpenChange={setOpen}>
                {dateApproved && !permissions['proposal.reopen'] &&
                    // <span className='text-body-secondary'>Only the Enquiry Manager can send/resend/reopen, if you need to do so please change yourself to the Enquiry Manager</span>
                    <span className='text-body-secondary'>To reopen the Proposal – change the Enquiry Manager to yourself</span>

                }
                <div className='d-flex justify-content-between p-0'>
                    <Dialog.Trigger
                        disabled={!(permissions['proposal.sendEnabled'] || permissions['proposal.fastTrackSubmit'])}
                        className={dateApproved ? 'button btn' : 'button_warning btn'}>
                        Prepare Proposal Email... {!dateApproved && ' (Self Approve)'}{!!dateEmailed && ' (Re-Issue)'}
                        {/*{!!dateEmailed ? 'Res' : 'S'}ubmit Proposal...{!dateApproved && ' (Fast Track)'}*/}
                    </Dialog.Trigger>

                    {!!dateApproved &&
                        <ProposalReopen disabled={!permissions['proposal.reopen']} rootUrl={rootUrl} loading={loading}
                                        errHandler={errHandler}
                                        resHandler={resHandler}/>
                    }
                </div>

                <Dialog.Portal>
                    <Dialog.Overlay className={'bg-opacity-50 bg-black position-fixed top-0 bottom-0 start-0 end-0'}
                                    style={{zIndex: '999999999999'}}/>
                    <Dialog.Content
                        onDragOver={(e) => e.preventDefault()}
                        onDragEnter={(e) => e.preventDefault()}
                        onDrop={(e) => {
                            if (e?.dataTransfer?.files?.length) {
                                e.preventDefault();
                                setFileList([...fileList, ...Array.from(e.dataTransfer.files)])
                            }
                        }}
                        className={'sendEmailDialog bg-white position-fixed top-50 start-50 pt-3 pb-3 ps-4 pe-4 translate-middle shadow-lg'}
                        style={{width: '70em', maxWidth: '100vw', zIndex: '9999999999999999', maxHeight: '100vh'}}>

                        <form ref={formRef} onSubmit={handleSubmit(onSubmit)} className='d-flex flex-column h-100'>
                            {/*<Dialog.Close className={'btn btn-close float-end'}></Dialog.Close>*/}
                            <div className='d-flex mt-2'>
                                <Dialog.Title className='m-0' style={{flexGrow: 1}}>{!!dateEmailed && 'Re-'}Issue
                                    Proposal Via
                                    Email</Dialog.Title>
                                <input type='submit' className='button' disabled={loading}
                                       value={loading ? 'Sending...' : 'Send Email'}
                                       style={{height: 30, marginRight: '1.5em'}}/>
                                <Dialog.Close className={'btn btn-close'}></Dialog.Close>
                            </div>
                            {!dateApproved &&
                                <div className={'alert alert-error mt-1'}>
                                    <h3 className='mt-1'>Self Approving Proposal</h3>
                                    <div>Proposal has not yet been Approved, continuing with sending this email will
                                        Self
                                        Approve and then Issue as normal.
                                    </div>
                                    <div>Aspects being approved:</div>
                                    {approvalRequirementList.map((requirement, i) =>
                                        <div className="d-flex ms-2 p-1"
                                             style={i ? {borderTop: 'solid orange 1px'} : {}}>
                                            <span style={{
                                                minWidth: '13em',
                                                width: '13em'
                                            }}>{requirement.approvalCategory}</span>
                                            {!!requirement.approvalRequirementDetails.length &&
                                                <ul className="m-0">
                                                    {requirement.approvalRequirementDetails.map(detail =>
                                                        <li>{detail}</li>)}
                                                </ul>
                                            }
                                        </div>)
                                    }

                                </div>
                            }
                            {!!issuesNotRequiringExtraApproval.length && dateApproved &&
                                <div className={'alert alert-warning-subtle mt-1'}>
                                    <h3 className='mt-1'>Potential Issues</h3>
                                    <ul className={'m-0'}>
                                        {issuesNotRequiringExtraApproval.map(issue => <li>{issue}</li>)}
                                    </ul>
                                </div>
                            }
                            <div className="mt-2 proposalSubmission flex-grow-1 d-flex flex-column">
                                {/*<Form action={`${rootUrl}/send`} control={control} headers={{"Content-Type": "multipart/form-data"}} >*/}
                                <div className={'d-flex mb-1 p-2 bg-light-subtle border'}>
                                    <div className="form-check form-switch" style={{width: '16em'}}>
                                        <input {...register('attachProposal')} className="form-check-input"
                                               type="checkbox" role="switch"
                                               id="flexSwitchCheckChecked"/>
                                        <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Attach
                                            Kiosk Proposal PDF When Sending
                                            <a onClick={e => {
                                                e.preventDefault();
                                                window.open(e.currentTarget.href, "Proposal PDF",
                                                    "status=no,resizable=yes,width=900,height=" + (window.screen.availHeight - 100)
                                                );
                                            }}
                                               title="Open Proposal PDF" target="_blank"
                                               style={{
                                                   marginLeft: '0.5em',
                                                   fontSize: 'large',
                                                   color: 'slategray',
                                                   fontFamily: 'wingdings3'
                                               }}
                                               href={`/proposal/${proposalId}/pdfinline`}></a>
                                        </label>
                                    </div>
                                    <FileInput fileList={fileList} setFileList={setFileList}/>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <label htmlFor='from' className='pe-2' style={{width: '5em'}}>From:</label>
                                    <span className='form-control w-auto border-0'>{fromEmail}</span>

                                </div>
                                <div className='d-flex align-items-center'>
                                    <label htmlFor='to' className='pe-2' style={{width: '5em'}}>To:</label>
                                    <ClientEmailInput getValues={getValues} setValue={setValue} register={register}
                                                      id='to'
                                                      autoFocus={true} fieldName={'recipients'}
                                                      emailContactList={emailContactList} required={true}/>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <label htmlFor='cc' className='pe-2' style={{width: '5em'}}>CC:</label>
                                    <ClientEmailInput getValues={getValues} setValue={setValue} register={register}
                                                      autoFocus={false} required={false} id='cc'
                                                      emailContactList={emailContactList} fieldName={'cc'}/>
                                </div>

                                <datalist id='emails'>
                                    {emailContactList?.map(c => <option
                                        value={c.email}>{c.name}</option>)}
                                </datalist>
                                <Subject subjectFields={subjectFields} register={register} name='subject' />
                                <textarea {...register('body')}
                                          required={true}
                                          className="form-control form-floating border-bottom-0 flex-grow-1"
                                          style={{minHeight: 0}}
                                          placeholder="Email Body"></textarea>
                            </div>
                            <div className='form-control border-top-0 h-auto'
                                 dangerouslySetInnerHTML={{__html: signatureHtml}}>
                            </div>
                        </form>
                    </Dialog.Content>
                </Dialog.Portal>
            </Dialog.Root>
        </>
    )

}
